import styled from 'styled-components';

export const WelcomeBarMain = styled('div')`
    background: linear-gradient(270deg, #214781 0%, #112441 100%);
    color: ${({ theme }) => theme.colors.white};
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    padding: 0.8rem 1rem;
    font-size: 20px;
    flex-wrap: wrap;
    gap: 20px;
    @media screen and (min-width: 1366px) {
        justify-content: center;
    }
`;

export const WelcomeBarContent = styled.div`
    background: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    align-items: center;
    @media screen and (min-width: 1366px) {
        max-width: 83rem;
        flex: 1;
    }
`;

export const TitleText = styled('div')`
    font-size: 20px;
    font-family: ${({ theme }) => theme.font.defaults.fontFamily};
    font-weight: 300;
    letter-spacing: 0;
    line-height: 38px;
    margin-bottom: 10px;
`;

export const DropDownWrapper = styled('div')`
    color: #0a4a8d;
    background: #fff;
    padding: 1px 5px;
    border-radius: 5px;
    cursor: pointer;
    display: flex;

    img {
        transition: transform 200ms ease-out 0s;
        transform: rotate(0deg);
    }
`;

export const DropDownHeader = styled('div')<{ isActive: boolean }>`
    cursor: pointer;
    align-self: center;
    padding: 0 3px;
    img {
        transition: transform 200ms ease-out 0s;
        transform: rotate(${({ isActive }) => (isActive ? '180deg' : '0deg')});
    }
`;

export const AccountText = styled.div`
    margin-bottom: 5px;
    font-size: 1rem;
`;

export const DropDownLable = styled.label`
    font-size: 1rem;
    padding: 0.4rem;
    cursor: pointer;
`;

export const NavigationTitle = styled.div`
    color: #fff;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 28px;

    @media screen and (max-width: 500px) {
        font-size: 21px;
    }
`;

export const DropDownContainer = styled.div`
    @media screen and (min-width: 629px) {
        margin-left: auto;
    }
`;

export const NavigationBreadCrumbContainer = styled.div`
    display: inline-block;
`;

export const NavigationBreadCrumb = styled.p`
    font-size: 14px;
    padding: 0;
    margin: 0 5px 0 0;
    font-weight: 300;
    cursor: pointer;
    float: left;
`;
